import React from 'react';

const OVERLAY = {
  position: 'fixed', inset: 0, backgroundColor: 'rgba(20, 40, 20, 0.55)',
  zIndex: 1200, display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: 16,
};

const CARD = {
  width: 560, maxWidth: '96vw',
  border: '2px solid',
  boxShadow: '0 8px 28px rgba(0,0,0,0.45)',
  padding: '18px 22px 22px',
  fontFamily: 'Arial, Helvetica, sans-serif',
};

const MEDAL = ['🥇', '🥈', '🥉'];

// ⚔ Combat Leaderboard modal — top N users by damage dealt to NPCs/monsters.
export const LeaderboardModal = ({ open, onClose, apiBase, myUsername }) => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState('');

  React.useEffect(() => {
    if (!open || !apiBase) return;
    let cancelled = false;
    setLoading(true); setErr('');
    (async () => {
      try {
        const r = await fetch(`${apiBase}/combat/top?limit=25`);
        const d = r.ok ? await r.json() : { top: [] };
        if (!cancelled) setRows(d.top || []);
      } catch (e) {
        if (!cancelled) setErr(String(e.message || e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [open, apiBase]);

  if (!open) return null;

  return (
    <div style={OVERLAY} onClick={onClose} data-testid="leaderboard-overlay">
      <div style={CARD} onClick={(e) => e.stopPropagation()} data-testid="leaderboard-modal" className="room-themed-panel">
        <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 20, letterSpacing: 1 }}>
          ⚔ Top Combatants of Mandala ⚔
        </div>
        <div style={{ textAlign: 'center', fontSize: 11, marginTop: 4, fontStyle: 'italic', opacity: 0.7 }}>
          Ranked by total HP damage dealt to NPCs and monsters.
        </div>

        <div
          data-testid="leaderboard-list"
          className="room-themed-bg room-themed-border"
          style={{
            marginTop: 14,
            border: '1px solid', maxHeight: 420, overflowY: 'auto',
          }}
        >
          {loading && <div style={{ padding: 18, textAlign: 'center' }}>Loading…</div>}
          {!loading && err && (
            <div style={{ padding: 18, textAlign: 'center', color: '#7a1a1a' }}>Error: {err}</div>
          )}
          {!loading && !err && rows.length === 0 && (
            <div style={{ padding: 22, textAlign: 'center', color: '#3a5a3a' }}>
              No combat records yet. Type <b>/attack Golem</b> in the chat to begin.
            </div>
          )}
          {!loading && !err && rows.length > 0 && (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr className="room-themed-header" style={{ textAlign: 'left' }}>
                  <th style={{ padding: '6px 10px', width: 42 }}>#</th>
                  <th style={{ padding: '6px 10px' }}>Champion</th>
                  <th style={{ padding: '6px 6px', textAlign: 'right', width: 72 }}>Damage</th>
                  <th style={{ padding: '6px 6px', textAlign: 'right', width: 60 }}>Hits</th>
                  <th style={{ padding: '6px 10px', textAlign: 'right', width: 60 }}>Kills</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => {
                  const isMe = myUsername && String(row.username || '').toLowerCase() === String(myUsername).toLowerCase();
                  return (
                    <tr
                      key={row.user_id || row.username || i}
                      data-testid={`leaderboard-row-${i + 1}`}
                      style={{
                        borderTop: '1px dotted #b6cf9c',
                        background: isMe ? '#e0f0c8' : 'transparent',
                        fontWeight: isMe ? 'bold' : 'normal',
                      }}
                    >
                      <td style={{ padding: '6px 10px' }}>
                        {i < 3 ? <span style={{ fontSize: 16 }}>{MEDAL[i]}</span> : (i + 1)}
                      </td>
                      <td style={{ padding: '6px 10px' }}>
                        {row.username || row.user_id}
                        {isMe && <span style={{ marginLeft: 6, fontSize: 10, color: '#1a5a10' }}>(you)</span>}
                      </td>
                      <td style={{ padding: '6px 6px', textAlign: 'right' }}>{row.damage_dealt}</td>
                      <td style={{ padding: '6px 6px', textAlign: 'right' }}>{row.hits}</td>
                      <td style={{ padding: '6px 10px', textAlign: 'right' }}>{row.kills}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: 14 }}>
          <button
            data-testid="leaderboard-close-btn"
            onClick={onClose}
            style={{
              backgroundColor: '#1c3a1c', color: '#ecfcd9',
              border: '1px solid #2d6b1e',
              padding: '5px 20px', fontWeight: 'bold', fontSize: 12,
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaderboardModal;
